<template>
  <v-card
    v-show="showBanner"
    class="year-summary-banner"
    elevation="8"
    :style="bannerStyle"
  >
    <v-card-text class="banner-content">
      <div class="banner-inner">
        <div class="banner-icon">
          <v-icon size="64" color="white">mdi-calendar-star</v-icon>
        </div>
        <div class="banner-text">
          <h2 class="banner-title">Ваши итоги 2025 года!</h2>
          <p class="banner-subtitle">
            Посмотрите свою статистику за год: заказы, клиенты, платежи и многое другое
          </p>
        </div>
        <div class="banner-actions">
          <v-btn
            color="white"
            large
            @click="viewSummary"
            class="banner-btn"
          >
            <v-icon left>mdi-chart-line</v-icon>
            Посмотреть
          </v-btn>
          <v-btn
            outlined
            color="white"
            large
            @click="remindTomorrow"
            class="banner-btn"
          >
            <v-icon left>mdi-clock-outline</v-icon>
            Напомнить завтра
          </v-btn>
          <v-btn
            text
            color="white"
            @click="dismissBanner"
            class="banner-btn-close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { swalMixin } from '@/utils/swal'

export default {
  name: 'YearSummaryBanner',
  mixins: [swalMixin],
  data() {
    return {
      showBanner: false,
      bannerDismissed: false,
    }
  },
  computed: {
    bannerStyle() {
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'fixed',
        top: '80px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        width: '100%',
        maxWidth: '1200px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      }
    }
  },
  mounted() {
    // Небольшая задержка для корректной проверки роута
    this.$nextTick(() => {
      this.checkBannerVisibility()
    })
  },
  watch: {
    '$route'(to) {
      // Не показываем баннер на странице итогов
      if (to.path === '/year-summary') {
        this.showBanner = false
      } else {
        this.checkBannerVisibility()
      }
    }
  },
  methods: {
    checkBannerVisibility() {
      // Не показываем баннер на странице итогов
      const currentPath = this.$route ? this.$route.path : window.location.pathname
      
      if (currentPath === '/year-summary') {
        this.showBanner = false
        return
      }

      // Проверяем, не прошла ли дата 10 января 2026
      const cutoffDate = new Date('2026-01-11')
      const today = new Date()
      
      if (today >= cutoffDate) {
        this.showBanner = false
        return
      }

      // Проверяем localStorage
      const dismissed = localStorage.getItem('yearSummaryBannerDismissed')
      const remindDate = localStorage.getItem('yearSummaryBannerRemindDate')
      
      if (dismissed === 'true') {
        this.showBanner = false
        return
      }

      if (remindDate) {
        const remind = new Date(remindDate)
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const remindStart = new Date(remind.getFullYear(), remind.getMonth(), remind.getDate())
        if (todayStart < remindStart) {
          this.showBanner = false
          return
        }
      }

      this.showBanner = true
    },
    viewSummary() {
      localStorage.setItem('yearSummaryBannerDismissed', 'true')
      this.$router.push('/year-summary')
    },
    remindTomorrow() {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0)
      localStorage.setItem('yearSummaryBannerRemindDate', tomorrow.toISOString())
      this.showBanner = false
    },
    async dismissBanner() {
      const result = await this.$swalWithColor({
        title: 'Скрыть баннер?',
        text: 'Баннер больше не будет показываться. Вы всегда можете посмотреть итоги года в боковом меню.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Да, скрыть',
        cancelButtonText: 'Отменить',
      })

      if (result.isConfirmed) {
        localStorage.setItem('yearSummaryBannerDismissed', 'true')
        this.showBanner = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/_variables.scss';

.year-summary-banner {
  margin: $spacing-3;
  animation: slideDown 0.5s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateX(-50%) translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.banner-content {
  padding: $spacing-6 !important;
}

.banner-inner {
  display: flex;
  align-items: center;
  gap: $spacing-4;
  flex-wrap: wrap;
}

.banner-icon {
  flex-shrink: 0;
}

.banner-text {
  flex: 1;
  min-width: 300px;
}

.banner-title {
  color: $color-white;
  font-size: $font-size-xl;
  font-weight: $font-weight-bold;
  margin-bottom: $spacing-2;
}

.banner-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: $font-size-md;
  margin: 0;
}

.banner-actions {
  display: flex;
  gap: $spacing-2;
  align-items: center;
  flex-wrap: wrap;
}

.banner-btn {
  text-transform: none;
  font-weight: $font-weight-medium;
}

.banner-btn-close {
  min-width: 40px;
}

@include mobile {
  .banner-inner {
    flex-direction: column;
    text-align: center;
  }

  .banner-text {
    min-width: 100%;
  }

  .banner-actions {
    width: 100%;
    justify-content: center;
  }

  .banner-btn {
    flex: 1;
    min-width: 140px;
  }
}
</style>

